<template>
    <div id="editProject">
        <el-dialog title="项目信息" :visible.sync="dialogEdit.show" width="25%" :modal-append-to-body="false">
            <el-form ref="formEdit" :model="form" label-width="80px">
                <el-form-item label="项目名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="项目地址" prop="address">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
                <el-form-item label="描述信息" prop="description">
                    <el-input v-model="form.description"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEdit.show = false">取消</el-button>
                <el-button type="primary" @click="dialogFormEdit('formEdit')">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

    export default {
        name: 'EditProject',
        /*prop类型*/
        props:{
          dialogEdit:Object,
          form:Object
        },
        data () {
            return {

            }
        },
        methods:{
            dialogFormEdit(){
                if(this.form.name == '' || this.form.address == '' || this.form.description == ''){
                    this.$message({
                        type:"warning",
                        message: '字段不能为空',
                    });
                    return
                }
                this.$axios.post('api/monitor/project/updateProject',this.form).then((res) => {
                    if(res.status == 200){
                        this.$message({
                            type:"success",
                            message: res.data.message,
                            showClose: true
                        });
                        this.dialogEdit.show = false;
                        this.$emit('updateEdit')  //更新父组件数据视图
                    }
                    return
                })
            }
        }
    }
</script>

<style>

    #editProject .el-dialog__header {
      text-align: center;
        padding: 20px 30px 10px;
        /*background-image: url('../../assets/img/modal_bg.png')*/
      background: linear-gradient(
        -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
      border-radius: 2.5px 2.5px 0px 0px;
      transition: unset;
    }

    #editProject .el-dialog__body {
        padding: 10px 20px;
    }

    #editProject .el-dialog__title{
      text-align: center;
        font-size: 18px;
        color: #fff;
    }

</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/EditProject.vue